<template>
  <v-container id="dashboard" fluid tag="section">
    <v-row justify="center" class="mx-10">
      <v-col cols="12" md="4">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Rates") }}</h2>
          </div>
          <!-- <a href="/ancillarycost" v-if="$ha(300)">
            <h4 class="my-2">
              <i class="icon-real-estate-045"></i>
              {{$i18n.t('Ancillary Cost')}}
            </h4>
          </a>-->
          <!-- <a href="/escortfare" v-if="$ha(290)">
            <h4 class="my-2">
              <i class="icon-travel-110"></i>
              {{ $i18n.t("Escort Fare") }}
            </h4>
          </a>-->
          <router-link v-if="$ha(700)" :to="'/tariffs'">
            <h4 class="my-2">
              <i class="icon-travel-021"></i>
              {{ $i18n.t("Tariff") }}
            </h4>
          </router-link>
        </div>
      </v-col>

      <v-col cols="12" md="4">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Billing") }}</h2>
          </div>
          <router-link v-if="$ha(890)" :to="'/sales/invoices'">
            <h4 class="my-2">
              <i class="icon-finance-174"></i>
              {{ $i18n.t("Invoice") }}
            </h4>
          </router-link>
          <!-- <a href="/bookinginvoice" v-if="$ha(340)" >
            <h4 class="my-2">
              <i class="icon-communication-025"></i>
              {{ $i18n.t("Booking Invoice") }}
            </h4>
          </a>-->
          <router-link v-if="$ha(760)" :to="'/paymentreceived'">
            <h4 class="my-2">
              <i class="icon-real-estate-027"></i>
              {{ $i18n.t("Payment Received") }}
            </h4>
          </router-link>
          <router-link v-if="$ha(340)" :to="'/paymentlog'">
            <h4 class="my-2">
              <i class="icon-christmas-006"></i>
              {{ $i18n.t("Payment Logs") }}
            </h4>
          </router-link>
          <router-link :to="'settings/fundaccounts'">
            <h4 class="my-2">
              {{ $i18n.t("Fund Accounts") }}
            </h4>
          </router-link>
          <router-link :to="'settings/transactions'">
            <h4 class="my-2">
              {{ $i18n.t("Account Transactions") }}
            </h4>
          </router-link>
        </div>
      </v-col>

      <v-col cols="12" md="4">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Configuration") }}</h2>
          </div>
          <router-link v-if="$ha(340)" :to="'/creditconfig'">
            <h4 class="my-2">
              <i class="fa fa-cogs"></i>
              {{ $i18n.t("Credit Config") }}
            </h4>
          </router-link>
          <!-- <a href="/convertcurrency" v-if="$ha(340)">
            <h4 class="my-2">
              <i class="icon-travel-048"></i>
              {{ $i18n.t("Convert Currency") }}
            </h4>
          </a>-->
          <router-link v-if="$ha(340)" :to="'/invoiceconfig'">
            <h4 class="my-2">
              <i class="icon-finance-050"></i>
              {{ $i18n.t("Invoice Config") }}
            </h4>
          </router-link>
          <router-link v-if="$ha(340)" :to="'/invoicesetup'">
            <h4 class="my-2">
              <i class="icon-finance-005"></i>
              {{ $i18n.t("Invoice Setup") }}
            </h4>
          </router-link>
          <!-- <a href="/markupconfig" v-if="$ha(340)">
            <h4 class="my-2">
              <i class="fa fa-cog"></i>
              {{ $i18n.t("Markup Config") }}
            </h4>
          </a>-->
          <router-link v-if="$ha(340)" :to="'/tariffconfig'">
            <h4 class="my-2">
              <i class="fa fa-cog"></i>
              {{ $i18n.t("Tariff Config") }}
            </h4>
          </router-link>
          <router-link v-if="$ha(340)" :to="'/taxslab'">
            <h4 class="my-2">
              <i class="fa fa-cog"></i>
              {{ $i18n.t("Tax Slab") }}
            </h4>
          </router-link>
          <!-- <a href="/transfergroup" v-if="$ha(340)">
            <h4 class="my-2">
              <i class="fa fa-cog"></i>
              {{ $i18n.t("Transfer Group") }}
            </h4>
          </a>-->
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SalesMenu",

  data() {
    return {};
  },

  methods: {
    complete(index) {
      this.list[index] = !this.list[index];
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>